import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthButton from '../Auth/AuthButton';
import { trackPricingView } from '../../utils/analytics';
import { useLanguage } from '../../context/LanguageContext';
import LanguageToggle from '../Chrome/LanguageToggle';
import './NewTopBar.css';

const NewTopBar: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="new-top-bar" style={{
      position: 'fixed',
      top: 'var(--app-chrome-height, 0px)',
      left: 0,
      right: 0,
      height: '70px',
      backgroundColor: 'white',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 20px',
      zIndex: 1000,
    }}>
      <div 
        className="brand-section"
        onClick={() => navigate('/')}
        style={{
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          cursor: 'pointer',
        }}
      >
        <img 
          className="logo"
          src="/DES-20250328_Logo_v3_SS.png"
          alt="ZoningPal Logo"
          style={{
            height: '40px',
            width: 'auto',
            marginRight: '12px',
          }}
        />
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
          <span className="brand-name" style={{
            fontSize: '22px',
            fontWeight: 600,
            color: '#333',
            lineHeight: 1.2,
            margin: 0,
          }}>{t.common.appName}</span>
          <span className="brand-tagline" style={{
            fontSize: '13px',
            color: '#666',
            lineHeight: 1.2,
            margin: 0,
          }}>{t.common.tagline}</span>
        </div>
      </div>
      
      <div className="nav-section" style={{
        display: 'flex',
        alignItems: 'center',
        gap: '24px',
      }}>
        <nav style={{
          display: 'flex',
          gap: '20px',
          alignItems: 'center',
        }}>
          <button
            onClick={() => navigate('/permitreview')}
            style={{
              background: 'none',
              border: 'none',
              color: '#64748b',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              padding: '8px 0',
              transition: 'color 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#2563eb';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#64748b';
            }}
          >
            {t.common.permitReview}
          </button>
          <button
            onClick={() => navigate('/blog')}
            style={{
              background: 'none',
              border: 'none',
              color: '#64748b',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              padding: '8px 0',
              transition: 'color 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#2563eb';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#64748b';
            }}
          >
            {t.common.blog}
          </button>
        </nav>
        
        <div className="auth-section" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}>
          <LanguageToggle compact />
          <AuthButton />
        </div>
      </div>
    </div>
  );
};

export default NewTopBar;
